import { useEffect, useRef } from 'react';
import { avatarStore } from '@/stores/avatarStore';
import { apiSwaggerClientSide } from '@/shared/api';
import { useIsUserAuthorized } from '@/utils/authHelpers';

export const useGlobalAvatar = () => {
  const isUserAuthorized = useIsUserAuthorized();
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    // Only make API call if user is authorized and we haven't loaded yet
    if (!isUserAuthorized) {
      console.log('User not authorized, skipping avatar API call');
      hasLoadedRef.current = false; // Reset when user becomes unauthorized
      return;
    }

    // Prevent multiple calls if already loaded
    if (hasLoadedRef.current) {
      console.log('Avatar already loaded, skipping API call');
      return;
    }

    console.log('Loading avatar for authorized user');
    hasLoadedRef.current = true;

    apiSwaggerClientSide.user.detailsList()
      .then((res) => {
        console.log('Avatar API response:', res.status);
        if (res.data?.avatarURL) {
          avatarStore.updateAvatarPath(res.data.avatarURL);
        }
      })
      .catch((err) => {
        console.error('Failed to fetch avatar details:', err);
        hasLoadedRef.current = false; // Reset on error to allow retry
      });
  }, [isUserAuthorized]);

  return {
    avatarUrl: avatarStore.finalAvatarUrl,
    loading: avatarStore.loading,
    error: avatarStore.error,
    setOptimisticAvatar: (url: string | null) =>
      avatarStore.setOptimisticUrl(url),
    clearOptimistic: () => avatarStore.clearOptimistic(),
    forceReload: (path?: string | null) => {
      hasLoadedRef.current = false; // Reset flag to allow reload
      avatarStore.forceReload(path ?? avatarStore.currentAvatarPath ?? '');
    },
    store: avatarStore,
  };
};
